import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00cb55ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav-bar" }
const _hoisted_2 = ["href"]

import { reactive } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TopBar',
  setup(__props) {

const items = [
  { name: "Úvod", href: "/" },
  { name: "Objednávky", href: "/objednavky" },
  { name: "Kontaktni informace", href: "/kontakt" },
];

const state = reactive({
  show: false,
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(items, (item) => {
        return _createElementVNode("li", {
          key: item.name
        }, [
          _createElementVNode("a", {
            href: item.href
          }, _toDisplayString(item.name), 9, _hoisted_2)
        ])
      }), 64))
    ])
  ]))
}
}

})